export const environment = {
    production: true,
    name: 'prod',
    googleAnalyticsTagId: 'GTM-53BG3TKH',
    dataHubOEMS: {
        "NissanTR": "35273",
        "InfinitiTR": "35050",
        "GMTR": "35541",
        "KIATR": "35047",
        "FordTR": "35456"
    },
    conquestEnrollmentConditions: {
        "NissanTR": true,
        "InfinitiTR": true,
        "GMTR": true,
        "KIATR": false,
        "FordTR": true
    },
    webEnrollmentDAMAPI: "https://axis-api-gw.epsilonrms.com/DAMAPI/dam/streamfile?path="
};
